import type { UseFormPayload } from '@domain-group/react-hooks'

import { digObject } from '@domain-group/javascript-utils'

import { Form } from '@domain-group/suit-theme'

import { UseAccountingIntegrationPayload, xeroInvoiceStatuses } from '@hooks/useAccountingIntegration'

interface ActiveSessionProps {
  accountingIntegrationPayload: UseAccountingIntegrationPayload,
  agencyFormPayload: UseFormPayload,
  disabled: boolean,
}

const ActiveSession = (props: ActiveSessionProps) => {
  const { accountingIntegrationPayload, agencyFormPayload, disabled } = props

  const { handlers } = agencyFormPayload

  const {
    defaultXeroCreditAccount,
    defaultXeroInvoiceStatus,
    defaultXeroSalesAccount,
    expenseAccounts,
    hasExpenseAccountMatch,
    hasRevenueAccountMatch,
    integrationData,
    revenueAccounts,
  } = accountingIntegrationPayload

  const xeroTenantName = digObject(integrationData, 'data.xero_tenant_name', '')

  return (
    <>
      <Form.Row marginTop="large">
        <Form.Field label="Connected Organisation">
          <input disabled value={xeroTenantName} />
        </Form.Field>

        {/*
         // @ts-expect-error TS2322 */}
        <Form.Field label="Default Invoice Status" marginTop={['large', 0]}>
          {/*
           // @ts-expect-error TS2322 */}
          <select
            disabled={disabled}
            name="options.default_xero_invoice_status"
            value={defaultXeroInvoiceStatus}
            {...handlers}
          >
            {xeroInvoiceStatuses.map(status => (
              <option key={status.value} value={status.value}>
                {status.title}
              </option>
            ))}
          </select>
        </Form.Field>
      </Form.Row>

      <Form.Row marginTop="large">
        <Form.Field label="Default Sales Account Name">
          {/*
           // @ts-expect-error TS2322 */}
          <select
            disabled={disabled}
            name="options.default_xero_account"
            value={defaultXeroSalesAccount}
            {...handlers}
          >
            <option value="">Other</option>
            {revenueAccounts.map(account => (
              <option key={account.code} value={account.code}>
                {account.name}
              </option>
            ))}
          </select>
        </Form.Field>

        {/*
         // @ts-expect-error TS2322 */}
        <Form.Field label="Default Credit Account Name" marginTop={['large', 0]}>
          {/*
           // @ts-expect-error TS2322 */}
          <select
            disabled={disabled}
            name="options.default_xero_credit_account"
            value={defaultXeroCreditAccount}
            {...handlers}
          >
            <option value="">Other</option>
            {expenseAccounts.map(account => (
              <option key={account.code} value={account.code}>
                {account.name}
              </option>
            ))}
          </select>
        </Form.Field>
      </Form.Row>

      <Form.Row marginTop="large">
        <Form.Field label="Default Sales Account Number">
          <input
            disabled={hasRevenueAccountMatch || disabled}
            name="options.default_xero_account"
            value={defaultXeroSalesAccount}
            {...handlers}
          />
        </Form.Field>

        {/*
         // @ts-expect-error TS2322 */}
        <Form.Field label="Default Credit Account Number" marginTop={['large', 0]}>
          <input
            disabled={hasExpenseAccountMatch || disabled}
            name="options.default_xero_credit_account"
            value={defaultXeroCreditAccount}
            {...handlers}
          />
        </Form.Field>
      </Form.Row>
    </>
  )
}

export default ActiveSession
